/* Nr. 15 (M04): Ausverkauft-Hinweis auf der Produktseite, Verhalten.
   Markup: snippets/lc-ausverkauft.liquid, Stile: assets/lc-ausverkauft.css.
   Haken: snippets/product-information-blocks.liquid (Preis-Zweig).
   Rueckweg: Hakenzeile entfernen, die drei Dateien lc-ausverkauft.* loeschen.

   Aufgaben:
   1. Das Formular von Restock Rocket (div#restock-rocket-inline-container, kommt erst nach
      einigen Sekunden von der App) in den Hinweis holen. Beobachter mit 60 s Lebenszeit.
      Verschieben erhaelt die Ereignisse der App.
   2. Kommt nach 20 s kein Formular: Ersatzknopf aus, Ersatzsatz ein (verspricht nichts).
      Lag der Fokus auf dem Ersatzknopf, geht er auf den Ersatzsatz. Kommt das Formular
      spaeter doch, wird der Zustand zurueckgenommen; lag der Fokus dann noch auf dem
      Ersatzsatz, geht er auf den Formularbereich (tabindex -1), nie in ein Eingabefeld
      (keine Tastatur am Handy, kein Tippen ins Feld ohne eigene Aktion).
   3. Ersatzknopf: springt zum Formular und setzt den Fokus ins E-Mail-Feld. Ist das
      Formular noch nicht da, steht ein Hinweis in der Live-Region, und der Fokus folgt,
      sobald es kommt, solange der Rueckfall noch nicht gegriffen hat.
   4. Messereignisse nach Konvention 4.5 (window.lcMessen, lc_ausverkauft_*, lc_nr 15).
   Kein globaler Name ausser window.lcMessen. Jeder Teil in try/catch, ein Fehler stoert
   die Seite nie. */
(function () {
  'use strict';

  var NR = '15';

  /* Gemeinsamer Messhelfer, gleiche kleine Kopie in jeder lc-Datei (Konvention 4.5). */
  window.lcMessen = window.lcMessen || function (name, daten) {
    try {
      if (typeof window.hj === 'function') { window.hj('event', name); }
    } catch (e) { /* Hotjar darf das Messen nie blockieren */ }
    try {
      if (!Array.isArray(window.dataLayer)) { window.dataLayer = []; }
      window.dataLayer.push(Object.assign({ event: name, lc_nr: NR }, daten || {}));
    } catch (e) { /* dataLayer darf das Messen nie blockieren */ }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, Object.assign({ lc_nr: NR }, daten || {}));
      }
    } catch (e) { /* Shopify Analytics darf das Messen nie blockieren */ }
  };

  function messen(name, daten) {
    try {
      window.lcMessen(name, Object.assign({ lc_nr: NR }, daten || {}));
    } catch (e) { /* Messen darf nie stoeren */ }
  }

  function start() {
    var wurzel = document.querySelector('[data-lc-aus]');
    if (!wurzel || wurzel.getAttribute('data-lc-aus-bereit') === '1') { return; }
    wurzel.setAttribute('data-lc-aus-bereit', '1');

    var ziel = wurzel.querySelector('[data-lc-aus-ziel]');
    var knopf = wurzel.querySelector('[data-lc-aus-notify]');
    var status = wurzel.querySelector('[data-lc-aus-status]');
    var ersatz = wurzel.querySelector('[data-lc-aus-ersatz]');
    if (!ziel) { return; }

    var handle = wurzel.getAttribute('data-lc-aus-handle') || '';
    var sprache = wurzel.getAttribute('data-lc-aus-sprache') || '';
    var land = '';
    try { land = (window.Shopify && window.Shopify.country) || ''; } catch (e) { land = ''; }
    var startzeit = Date.now();
    var formularDa = false;
    var wartet = false;
    var beobachter = null;
    var geplant = false;

    messen('lc_ausverkauft_ansicht', { handle: handle, land: land, sprache: sprache });

    function formular() {
      return document.getElementById('restock-rocket-inline-container');
    }

    function emailFeld(f) {
      return (f || formular() || document).querySelector('#form-Email');
    }

    function zeigeFormular(f) {
      var erstes = !formularDa;
      formularDa = true;
      ziel.classList.remove('lc-aus__ziel--ohne');
      ziel.classList.add('lc-aus__ziel--da');
      var ersatzFokus = !!(ersatz && document.activeElement === ersatz);
      if (ersatz) { ersatz.hidden = true; }
      if (ersatzFokus) {
        /* Fokus lag auf dem jetzt verborgenen Ersatzsatz: nicht verlieren, aber auch nicht
           ins E-Mail-Feld legen (spaet, ohne eigene Aktion). Ziel ist der Formularbereich. */
        try {
          if (!ziel.hasAttribute('tabindex')) { ziel.setAttribute('tabindex', '-1'); }
          ziel.focus({ preventScroll: true });
        } catch (e3) { /* ignorieren */ }
      }
      if (status) { status.textContent = ''; }
      if (erstes) {
        messen('lc_ausverkauft_formular_sichtbar', {
          handle: handle,
          wartezeit_ms: Math.round(window.performance && performance.now ? performance.now() : Date.now() - startzeit)
        });
      }
      if (wartet) {
        wartet = false;
        var reduziert = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (f && f.scrollIntoView) { f.scrollIntoView({ block: 'center', behavior: reduziert ? 'auto' : 'smooth' }); }
        var e = emailFeld(f);
        if (e && typeof e.focus === 'function') { e.focus({ preventScroll: true }); }
      }
    }

    function pruefen() {
      geplant = false;
      try {
        var f = formular();
        if (!f) { return; }
        if (f.parentElement !== ziel) {
          ziel.appendChild(f);
        }
        if (!formularDa || !ziel.classList.contains('lc-aus__ziel--da')) { zeigeFormular(f); }
      } catch (e) { /* Verschieben darf die Seite nie stoeren */ }
    }

    function planen() {
      if (geplant) { return; }
      geplant = true;
      setTimeout(pruefen, 50);
    }

    /* 1. Beobachter, 60 s Lebenszeit */
    try {
      if (typeof MutationObserver === 'function') {
        beobachter = new MutationObserver(planen);
        beobachter.observe(document.body, { childList: true, subtree: true });
        setTimeout(function () {
          try { if (beobachter) { beobachter.disconnect(); } } catch (e) { /* ignorieren */ }
        }, 60000);
      }
    } catch (e) { beobachter = null; }
    pruefen();

    /* 2. Rueckfall nach 20 s */
    setTimeout(function () {
      try {
        if (formular() || formularDa) { return; }
        var hatteFokus = !!(knopf && document.activeElement === knopf);
        wartet = false;
        ziel.classList.add('lc-aus__ziel--ohne');
        if (ersatz) {
          ersatz.hidden = false;
          if (hatteFokus && typeof ersatz.focus === 'function') { ersatz.focus({ preventScroll: true }); }
        }
        messen('lc_ausverkauft_formular_fehlt', { handle: handle });
      } catch (e) { /* ignorieren */ }
    }, 20000);

    /* 3. Ersatzknopf */
    if (knopf) {
      knopf.addEventListener('click', function () {
        try {
          messen('lc_ausverkauft_notify_klick', { handle: handle, quelle: 'ersatz', gueltig: false });
          var f = formular();
          if (!f) {
            wartet = true;
            if (status) {
              /* Leeren und neu setzen, damit auch ein zweiter Klick angesagt wird */
              status.textContent = '';
              setTimeout(function () {
                try {
                  if (!formularDa && !ziel.classList.contains('lc-aus__ziel--ohne')) {
                    status.textContent = wurzel.getAttribute('data-lc-aus-wartet') || '';
                  }
                } catch (e2) { /* ignorieren */ }
              }, 100);
            }
            return;
          }
          var reduziert = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (f.scrollIntoView) { f.scrollIntoView({ block: 'center', behavior: reduziert ? 'auto' : 'smooth' }); }
          var e = emailFeld(f);
          if (e && typeof e.focus === 'function') { e.focus({ preventScroll: true }); }
        } catch (err) { /* ignorieren */ }
      });
    }

    /* 4. Klicks: Formularknopf der App (delegiert) und Alternativen */
    document.addEventListener('click', function (ev) {
      try {
        var t = ev.target;
        if (!t || !t.closest) { return; }
        var fk = t.closest('#form-Button');
        if (fk && ziel.contains(fk)) {
          var e = emailFeld();
          var gueltig = !!(e && e.value && (typeof e.checkValidity !== 'function' || e.checkValidity()));
          messen('lc_ausverkauft_notify_klick', { handle: handle, quelle: 'formular', gueltig: gueltig });
          return;
        }
        var alt = t.closest('[data-lc-aus-alt]');
        if (alt && wurzel.contains(alt)) {
          messen('lc_ausverkauft_alternative_klick', {
            handle: handle,
            ziel: alt.getAttribute('data-lc-aus-alt') || '',
            position: parseInt(alt.getAttribute('data-lc-aus-pos'), 10) || 1
          });
        }
      } catch (err) { /* ignorieren */ }
    }, true);
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  } catch (e) { /* ignorieren */ }
})();
